import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { fetchCartitemslice } from "./cartItemSlice";
import { api } from "../components/Constants";
export const addtoCart = createAsyncThunk(
  "cart/addtocart",
  async ({ product_id, userids, qty, size, carat, weight, remarks }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(api + "add_cart", {
        dealer_id: userids,
        product_id: product_id,
        qty: qty,
        size: size,
        carat: carat,
        weight: weight,
        remarks: remarks,
      });

      if (response.status === 200) {

        toast.success(<div>
          <strong>Success!</strong>
          <p>{response.data.message}</p>
        </div>, {
          style: {
            background: "#ffffff",
            color: "#bc1823 ",
            padding: "16px",
            textAlign: "center",
            fontSize: "16px",
            fontWeight: "bold",
            borderRadius: "10px"
          },
          autoClose: 1000
        });
        dispatch(fetchCartitemslice({ userids }));
        return response.data;
      } else {
        toast.error("Something went wrong");
        return rejectWithValue(
          "Unexpected response status: " + response.status
        );
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to add to cart" && error.message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const removeFromCart = createAsyncThunk(
  "cart/removeFromCart",
  async ({ product_id, userid }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(api + "remove_cart", {
        dealer_id: userid,
        product_id: product_id,
      });

      if (response.status === 200) {
        toast.error("Removed from cart", {
          autoClose: 2000,
          className: "custom-toast",
        });
      }
      // Fetch updated cart items after removing the product
      dispatch(fetchCartitemslice({ userid }));
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "Failed to remove product from cart";
      // Display dynamic error message from API

      return rejectWithValue(errorMessage);
    }
  }
);

const initialState = {
  cart: [],
  status: "idle",
  loading: false,
  error: null,
};

const cartreducer = createSlice({
  name: "cart",
  initialState,
  reducers: {},
  extraReducers: (building) => {
    building
      .addCase(addtoCart.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(addtoCart.fulfilled, (state, action) => {
        state.status = "succeded";
        state.loading = false;
      })
      .addCase(addtoCart.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(removeFromCart.pending, (state) => {
        state.status = "loading";
      })
      .addCase(removeFromCart.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(removeFromCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default cartreducer.reducer;
